import styled from "@emotion/styled";
import { Paper, tabClasses, tabsClasses } from "@mui/material";

export const ViewQuoteTableContainer = styled(Paper)(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	display: "flex",
	flexDirection: "column",
	padding: "16px",
	overflowX: "auto",
	marginBottom: "16px",
	// Tab styling to match design system
	[`& .${tabsClasses.root}`]: {
		minHeight: "42px",
		letterSpacing: ".4px",
		[`& .${tabClasses.selected}`]: {
			color: theme.project.colors.primaryColors.main
		}
	},
	[`& .${tabsClasses.indicator}`]: {
		backgroundColor: theme.project.colors.primaryColors.main
	}
}));

/**
 * Header container with inline layout for tabs, filters, and search
 *
 * Replicates the SaveDraft table layout pattern with:
 * - Flex layout for horizontal alignment
 * - Responsive breakpoints for mobile stacking
 * - Consistent spacing and proportions
 */
export const CustomQuoteExteriorTableHeader = styled.div(({ theme }) => ({
	marginBottom: 16,
	display: "flex",
	alignItems: "flex-start",
	justifyContent: "space-between",
	// Tab button styling
	button: {
		[`&.${tabClasses.selected}`]: {
			color: theme.project.colors.primaryColors.main
		}
	},
	// Tab indicator styling
	[`& .${tabsClasses.indicator}`]: {
		backgroundColor: theme.project.colors.primaryColors.main
	},
	// Custom Quote specific: Force SuggestedSearch to 300px width
	"& #custom-quote-search": {
		minWidth: 300
	},
	flexDirection: "column",
	gap: "16px"
}));

export const ViewQuoteTableFilters = styled.div(
	({ theme }) =>
		({
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			width: "100%",

			[theme.breakpoints.down("md")]: {
				flexDirection: "column",
				alignItems: "flex-start",
				gap: "16px",

				"&& > div": {
					flexDirection: "row",
					display: "flex",
					gap: "8px"
				}
			}
		}) as const
);

export const ExpiredQuotesInfo = styled("div")(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.secondary,
	marginBottom: 16
}));
